"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newMeasureMetadataObject = exports.MeasureMetadataObjectBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var factory_1 = require("./factory");
var builder_1 = require("../builder");
/**
 * Measure metadata object builder
 * See {@link Builder}
 *
 * @beta
 */
var MeasureMetadataObjectBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(MeasureMetadataObjectBuilder, _super);
    function MeasureMetadataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MeasureMetadataObjectBuilder.prototype.expression = function (maql) {
        this.item.expression = maql;
        return this;
    };
    MeasureMetadataObjectBuilder.prototype.format = function (format) {
        this.item.format = format;
        return this;
    };
    MeasureMetadataObjectBuilder.prototype.isLocked = function (isLocked) {
        this.item.isLocked = isLocked;
        return this;
    };
    return MeasureMetadataObjectBuilder;
}(factory_1.MetadataObjectBuilder));
exports.MeasureMetadataObjectBuilder = MeasureMetadataObjectBuilder;
/**
 * Measure metadata object factory
 *
 * @param ref - measure reference
 * @param modifications - measure builder modifications to perform
 * @returns created measure metadata object
 * @beta
 */
exports.newMeasureMetadataObject = function (ref, modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(MeasureMetadataObjectBuilder, { type: "measure", ref: ref }, modifications);
};
//# sourceMappingURL=measureFactory.js.map